import activeTabs from '../../../../../../javascript/modules/Gull/Framework/activeTabs.js';
import stap1 from './aanvraagIndienen/stap1.js';
import stap2 from '../MV7xx/aanvraagIndienen/stap2.js';
import stap3 from '../MV7xx/aanvraagIndienen/stap3.js';
import stap4 from '../MV7xx/aanvraagIndienen/stap4.js';

const aanvraagIndienen = {

	init() {
		activeTabs.initTab([stap1, stap2, stap3, stap4]);
	},

};

export default aanvraagIndienen;
